import { createSelector } from 'reselect';

export const selectedValidatedlaims = (state: any) => {
  return state.get('validatedClaims');
};

const makeSelectValidatedClaims = () =>
  createSelector(selectedValidatedlaims, claims => {
    if (claims && claims.get('claims')) {
      return claims.get('claims').toJS();
    }
    return [];
  });

const makeSelectCountValidatedClaims = () =>
  createSelector(selectedValidatedlaims, claims => {
    if (claims && claims.get('countClaims')) {
      return claims.get('countClaims');
    }
    return 0;
  });

export { makeSelectValidatedClaims, makeSelectCountValidatedClaims };
